// NPM Imports
import React, { Component, Fragment } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Input, Button } from "../../../revvComponents";
import { ReactSelect } from "../../../commonComponents";
import { GRID } from "../../../constants";

// Destructuring
const { PRODUCT_COLUMN_FIELD_TYPE } = GRID;

class AddPricebookFields extends Component {
  state = {
    showOptions:
      (this.props.data ? this.props.data.standard : false) ||
      (this.props.data &&
        this.props.data.columnType &&
        this.props.data.columnType === "LookUpColumn"),
    showValueoption: this.props.data
      ? this.props.data.name === "recurring_period" ||
        this.props.data.name === "charge_type" ||
        this.props.data.name === "charge_frequency"
      : false,
  };

  _getSelectedFieldTypeOptions = () => {
    switch (this.props.type) {
      case "Text":
        return null;
      case "Number":
        return null;
      case "Single Select":
        return (
          <Fragment>
            {this.props.errMsg && (
              <div className="assetmodal-error-message">
                Values in picklist are not allowed. Change a repeated value and
                save again.
              </div>
            )}
            {this.props.fieldTypeOptions.map((data, index) => (
              <div
                key={data.id}
                className="revv-form-items"
                data-test="commondynamicfields-revv-form-items-fielddescription">
                <div className="custom-feild-formitem">
                  <span
                    className="revvform-label"
                    data-test="commondynamicfields-revvform-label-fielddescription">
                    Value {`(${index + 1})`}
                    <span
                      className="requiredwitherr-input"
                      data-test="commondynamicfields-requiredwitherr-input-fielddescription">
                      *
                    </span>
                  </span>
                  <div className="checkboxpos">
                    {this.props.fieldTypeOptions.length > 1 &&
                      !data.isLocked && (
                        <div className="customselect-delete-option">
                          <span
                            className="btn-icon"
                            onClick={() =>
                              this.props.onFieldTypeOptionRemove(data.id)
                            }
                            onKeyPress={() => {}}
                            role="button"
                            tabIndex="0">
                            <FontAwesomeIcon icon={["far", "trash-alt"]} />
                          </span>
                        </div>
                      )}
                  </div>
                </div>
                <Input
                  autoFocus
                  id="COLUMN DESCRIPTION"
                  data-test="commondynamicfields-fielddescription-input"
                  type="text"
                  name="description"
                  value={data.value}
                  onChange={e =>
                    this.props.onFieldTypeOptionChange(e.target.value, data.id)
                  }
                  required
                  disabled={data.isLocked}
                />
              </div>
            ))}
            {!this.state.showValueoption && (
              <div
                className="clause-options-add-option"
                data-test="clauseoptions-options-add-option-button-text">
                <Button
                  className="revv-btn-secondary-sm"
                  data-test="clauseoptions-options-add-option-button"
                  onClick={this.props.onFieldTypeOptionAdd}
                  onKeyDown={() => {}}
                  role="button"
                  tabIndex={0}>
                  <i>
                    <FontAwesomeIcon icon={["far", "plus"]} />
                  </i>
                  Add another value
                </Button>
              </div>
            )}
          </Fragment>
        );
      case "Multi Select":
        return (
          <Fragment>
            {this.props.errMsg && (
              <div className="assetmodal-error-message">
                Values in picklist are not allowed. Change a repeated value and
                save again.
              </div>
            )}
            {this.props.fieldTypeOptions.map((data, index) => (
              <div
                key={data.id}
                className="revv-form-items"
                data-test="commondynamicfields-revv-form-items-fielddescription">
                <div className="custom-feild-formitem">
                  <span
                    className="revvform-label"
                    data-test="commondynamicfields-revvform-label-fielddescription">
                    Value {`(${index + 1})`}
                    <span
                      className="requiredwitherr-input"
                      data-test="commondynamicfields-requiredwitherr-input-fielddescription">
                      *
                    </span>
                  </span>
                  <div className="checkboxpos">
                    {this.props.fieldTypeOptions.length > 1 &&
                      !data.isLocked && (
                        <div className="customselect-delete-option">
                          <span
                            className="btn-icon"
                            onClick={() =>
                              this.props.onFieldTypeOptionRemove(data.id)
                            }
                            onKeyPress={() => {}}
                            role="button"
                            tabIndex="0">
                            <FontAwesomeIcon icon={["far", "trash-alt"]} />
                          </span>
                        </div>
                      )}
                  </div>
                </div>
                <Input
                  autoFocus
                  id="COLUMN DESCRIPTION"
                  data-test="commondynamicfields-fielddescription-input"
                  type="text"
                  name="description"
                  value={data.value}
                  onChange={e =>
                    this.props.onFieldTypeOptionChange(e.target.value, data.id)
                  }
                  required
                  disabled={data.isLocked}
                />
              </div>
            ))}

            <div
              className="clause-options-add-option"
              data-test="clauseoptions-options-add-option-button-text">
              <Button
                className="revv-btn-secondary-sm"
                data-test="clauseoptions-options-add-option-button"
                onClick={this.props.onFieldTypeOptionAdd}
                onKeyDown={() => {}}
                role="button"
                tabIndex={0}>
                <i>
                  <FontAwesomeIcon icon={["far", "plus"]} />
                </i>
                Add another value
              </Button>
            </div>
          </Fragment>
        );
      default:
        return null;
    }
  };

  render() {
    return (
      <React.Fragment>
        <div className="product-commonfields">
          <div
            className="revv-form-items"
            data-test="commondynamicfields-revv-form-items-fieldname">
            <span
              className="revvform-label"
              data-test="commondynamicfields-revvform-label-fieldname">
              Column title
              <span
                className="requiredwitherr-input"
                data-test="commondynamicfields-requiredwitherr-input-fieldname">
                *
              </span>
            </span>
            <Input
              autoFocus
              id="COLUMN TITLE"
              data-test="commondynamicfields-fieldname-input"
              name="name"
              type="text"
              value={this.props.title}
              placeholder="Enter column title"
              onChange={e => this.props.onInputChange("title", e.target.value)}
              required
            />
          </div>
          {/* <div
            className="revv-form-items"
            data-test="commondynamicfields-revv-form-items-fieldname">
            <span
              className="revvform-label"
              data-test="commondynamicfields-revvform-label-fieldname">
              Column description
              <span
                className="requiredwitherr-input"
                data-test="commondynamicfields-requiredwitherr-input-fieldname">
                *
              </span>
            </span>
            <Input
              id="COLUMN DESCRIPTION"
              data-test="commondynamicfields-fieldname-input"
              name="name"
              type="text"
              value={this.props.description}
              placeholder="Enter column description"
              onChange={e =>
                this.props.onInputChange("description", e.target.value)
              }
              required
            />
          </div> */}
          <div
            className="revv-form-items"
            data-test="commondynamicfields-revv-form-items-fielddescription">
            <span
              className="revvform-label"
              data-test="commondynamicfields-revvform-label-fielddescription">
              Column field type{" "}
              <span
                className="requiredwitherr-input"
                data-test="commondynamicfields-requiredwitherr-input-fielddescription">
                *
              </span>
            </span>
            <ReactSelect
              isSearchable
              valueKey="type"
              onChange={value => this.props.onSelectChange(value)}
              options={PRODUCT_COLUMN_FIELD_TYPE}
              value={this.props.type}
              data-test="addgridcolumn-type-select"
              isDisabled={this.props.isEditFlow}
            />
          </div>
          {this._getSelectedFieldTypeOptions()}
          {!this.state.showOptions && (
            <div
              className="revv-form-items product-addcolumn-footer"
              data-test="commondynamicfields-revv-form-items-fielddescription">
              <span
                className="revvform-label"
                data-test="commondynamicfields-revvform-label-fielddescription">
                <Input
                  data-test="commondynamicfields-fielddescription-input"
                  isSwitch
                  type="checkbox"
                  value=""
                  checked={this.props.showColInQuoteTable}
                  onClick={() =>
                    this.props.onToggleBoxChange("showColInQuoteTable")
                  }
                  disabled={
                    this.props.isEditFlow && this.props.showColInQuoteTable
                  }
                />
                <span
                  className="product-column-footer-options"
                  data-test="commondynamicfields-requiredwitherr-input-fielddescription">
                  Show column in quote table tab in document
                </span>
              </span>
            </div>
          )}
          {/* <div
            className="revv-form-items"
            data-test="commondynamicfields-revv-form-items-fielddescription">
            <span
              className="revvform-label"
              data-test="commondynamicfields-revvform-label-fielddescription">
              <Input
                data-test="commondynamicfields-fielddescription-input"
                isSwitch
                type="checkbox"
                value=""
                checked={this.props.showColInPriceBook}
                onClick={() =>
                  this.props.onToggleBoxChange("showColInPriceBook")
                }
              />
              <span
                className="product-column-footer-options"
                data-test="commondynamicfields-requiredwitherr-input-fielddescription">
                Allow editing in quote table
              </span>
            </span>
          </div> */}
          <div
            className="revv-form-items"
            data-test="commondynamicfields-revv-form-items-fielddescription">
            <span
              className="revvform-label"
              data-test="commondynamicfields-revvform-label-fielddescription">
              <Input
                data-test="commondynamicfields-fielddescription-input"
                isSwitch
                type="checkbox"
                value=""
                checked={this.props.hideColInProductCatalog}
                onClick={() =>
                  this.props.onToggleBoxChange("hideColInProductCatalog")
                }
              />
              <span
                className="product-column-footer-options"
                data-test="commondynamicfields-requiredwitherr-input-fielddescription">
                Hide column from view in pricebook catalog
              </span>
            </span>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default AddPricebookFields;
